import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20fcb29b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "notice",
  class: "form-view"
}
const _hoisted_2 = { class: "tabs-wrap" }

import {computed, defineAsyncComponent, ref} from "vue";
import {Setting} from "@element-plus/icons-vue";
import NoticeList from "@/views/member/notice/components/NoticeList.vue";
import Settings from "@/views/member/notice/components/Settings.vue";
import {queryMessageListApi, queryUnreadRemindApi} from "@/api/message";

// 引入组件

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const MainTitle = defineAsyncComponent(() => import("@/views/member/components/MainTitle.vue"));

/**
 * 当前选中选项卡
 */
const activeName = ref('system');

/**
 * 选项卡列表
 */
const tabList = ref([
  {tab: 'system', name: '系统公告', tips: '系统公告（网站管理员后台发布）', id: '1', read: 0, tabId: 'xitong'},
  {tab: 'file', name: '文件提醒', tips: '文件提醒（包含操作记录，到期前提醒，到期提醒，访客提醒等提醒）', id: '3', read: 0, tabId: 'file'},
  {tab: 'account', name: '账号提醒', tips: '账户提醒（包含开通、续费、即将到期、已到期等提醒）', id: '2', read: 0, tabId: 'zhanghu'},
]);

/**
 * 设置弹窗展示状态
 */
const settingsVisible = ref(false);

/**
 * 显示设置弹窗
 */
const showSettings = () => {
  settingsVisible.value = true;
};

/**
 * 设置弹窗关闭
 */
const handleSettingsClose = () => {
  settingsVisible.value = false;
}

/**
 * 判断是否有未读消息
 */
const hasUnreadMessage = async () => {
  let data:any = await queryUnreadRemindApi()
  for (let dataKey in data) {
    let item:any = tabList.value.find(item => item.tabId === dataKey)
    item.read = data[dataKey] || 0
  }
}
hasUnreadMessage();

/**
 * 获取选中选项卡的id
 */
const getActiveTabId = computed(() => {
  return tabList.value.find(item => item.tab === activeName.value)?.id;
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(MainTitle), null, {
      default: _withCtx(() => [
        _createTextVNode("消息中心")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        link: "",
        icon: _unref(Setting),
        class: "setting-btn",
        onClick: showSettings
      }, {
        default: _withCtx(() => [
          _createTextVNode("消息设置")
        ]),
        _: 1
      }, 8, ["icon"]),
      _createVNode(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: item.tab,
              name: item.tab
            }, {
              label: _withCtx(() => [
                _createVNode(_component_el_badge, {
                  "is-dot": "",
                  class: "item",
                  hidden: item.read === 0
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["hidden"])
              ]),
              default: _withCtx(() => [
                (activeName.value === item.tab)
                  ? (_openBlock(), _createBlock(NoticeList, {
                      key: 0,
                      "tab-name": getActiveTabId.value
                    }, null, 8, ["tab-name"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: settingsVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((settingsVisible).value = $event)),
      title: "消息设置",
      width: "920px"
    }, {
      default: _withCtx(() => [
        (settingsVisible.value)
          ? (_openBlock(), _createBlock(Settings, {
              key: 0,
              "tab-list": tabList.value,
              onClose: handleSettingsClose
            }, null, 8, ["tab-list"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})